import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { getCurrentLocale } from '@probatix/common/translations'
import { ResetForm, Token } from '@probatix/common/services/toolkit/accounts/accountsService.model'
import { API_MY_PROBATIX_ENTRYPOINT } from '@probatix/common/config/app'

import { DOBCheckPayload, SignupActivatePayload } from './activationService.model'
import { setJWT } from '../patients'

const baseUrl = API_MY_PROBATIX_ENTRYPOINT

const returnHeader = () => ({
  Accept: 'application/json',
  'Accept-Language': getCurrentLocale().code.slice(0, 2),
  'Content-Type': 'application/json',
})

// Define a service using a base URL and expected endpoints
export const activationApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: '' }),
  endpoints: (builder) => ({
    postAccountActivation: builder.mutation<{ activationToken; dateOfBirth; password; uuid; },DOBCheckPayload>({
      query: ({ activationToken, dateOfBirth, password, uuid }) => ({
        body: {
          activationToken,
          dateOfBirth,
          password,
          uuid,
        },
        credentials: 'include',
        headers: returnHeader(),
        method: 'POST',
        url: `${baseUrl}/users/activate`,
      }),
      transformResponse: (responseData: any) => setJWT(responseData),
    }),
    postCheckResetPassword: builder.mutation<any, Token>({
      query: ({ token }) => ({
        body: {
          token,
        },
        credentials: 'include',
        headers: returnHeader(),
        method: 'POST',
        url: `${baseUrl}/patients/reset_password/check-token`,
      }),
    }),
    postResetPassword: builder.mutation<any, ResetForm>({
      query: ({ password, token }) => ({
        body: {
          password,
          token,
        },
        credentials: 'include',
        headers: returnHeader(),
        method: 'POST',
        url: `${baseUrl}/patients/reset_password`,
      }),
      transformResponse: (responseData: any) => setJWT(responseData),
    }),
    postSignedUpAccountActivation: builder.mutation<{ uuid; }, SignupActivatePayload >({
      query: ({ uuid }) => ({
        body: {
          uuid,
        },
        credentials: 'include',
        headers: returnHeader(),
        method: 'POST',
        url: `${baseUrl}/patients/activate`,
      }),
    }),
  }),
  reducerPath: 'activationApi',
})

export const usePostAccountActivation = activationApi.endpoints.postAccountActivation.useMutation
export const usePostResetPassword = activationApi.endpoints.postResetPassword.useMutation
export const usePostCheckResetPassword = activationApi.endpoints.postCheckResetPassword.useMutation
export const usePostSignedUpAccountActivation = activationApi.endpoints.postSignedUpAccountActivation.useMutation
